export default function (Component) {
      Component.options.$frontmatter = {"layout":"@/components/layout/MarkdownView.vue","title":"Terms of Use","author":"Admin","date":"2020-05-17T21:06:28.195Z"};
    }